import React from "react";

const DeliveredArea = ({ deliveredArea = [] }) => {
  // ✅ Calculate total area
  const calculateTotal = () => {
    return deliveredArea.reduce((acc, item) => {
      const areaValue = parseInt(item.area.replace(/,/g, "")) || 0;
      return acc + areaValue;
    }, 0);
  };

  // ✅ Format number with commas
  const formatNumber = (num) => {
    if (!num) return "0";
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  const totalArea = calculateTotal();

  return (
    <section className="py-12 sm:py-16 md:py-20 px-4 sm:px-6 md:px-8 bg-gradient-to-br from-blue-50 via-white to-teal-50">
      <div className="container mx-auto max-w-6xl">
        {/* Header */}
        <div className="text-center mb-8 sm:mb-10 md:mb-12">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-[#0D9488]">
            Delivered Area by Project
          </h2>
        </div>

        {/* Delivered Area List */}
        {deliveredArea && deliveredArea.length > 0 ? (
          <div className="bg-white rounded-2xl shadow-lg p-6 sm:p-8 md:p-10 border border-gray-200">
            <div className="divide-y divide-gray-100">
              {deliveredArea.map((item, index) => (
                <div
                  key={index}
                  className="flex flex-col sm:flex-row sm:justify-between sm:items-center py-4 sm:py-5 gap-3 sm:gap-0 hover:bg-blue-50/60 rounded-lg px-3 transition-all duration-200"
                >
                  {/* Left: Project Name */}
                  <div className="flex items-center gap-3">
                    <div className="flex items-center justify-center w-8 h-8 sm:w-9 sm:h-9 bg-gradient-to-br from-blue-500 to-teal-500 rounded-lg shadow-sm flex-shrink-0">
                      <svg
                        className="w-4 h-4 sm:w-5 sm:h-5 text-white"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
                        />
                      </svg>
                    </div>
                    <span className="text-base sm:text-lg md:text-xl font-semibold text-gray-800">
                      {item.project}
                    </span>
                  </div>

                  {/* Right: Area */}
                  <div className="flex items-baseline gap-1 justify-end">
                    <span className="text-lg sm:text-xl md:text-2xl font-bold bg-gradient-to-r from-blue-600 to-teal-600 bg-clip-text text-transparent">
                      {item.area}
                    </span>
                    <span className="text-xs sm:text-sm font-medium text-gray-500">
                      sq ft
                    </span>
                  </div>
                </div>
              ))}
            </div>

            {/* ✅ Total Delivered Section - Matching Admin Style */}
            <div className="flex justify-between items-center py-4 sm:py-5 bg-gradient-to-r from-[#1A81BA] to-[#5AA650] text-white px-4 sm:px-6 rounded-lg mt-6 sm:mt-8 shadow-md">
              <span className="text-lg sm:text-xl font-bold">Total Delivered</span>
              <span className="text-lg sm:text-xl font-bold">
                {formatNumber(totalArea)} sq ft
              </span>
            </div>
          </div>
        ) : (
          /* Empty State */
          <div className="text-center bg-white rounded-2xl shadow-md py-10 sm:py-12 px-4 border border-gray-200">
            <svg
              className="w-10 h-10 sm:w-12 sm:h-12 mx-auto mb-3 text-gray-400"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4"
              />
            </svg>
            <p className="text-gray-500 text-sm sm:text-base">
              No delivered area data available
            </p>
          </div>
        )}
      </div>
    </section>
  );
};

export default DeliveredArea;